var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2A7DFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33083_178882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5856 21.439H19.267V22.0728H10.5856V21.439ZM10.5856 18.7772H19.267V19.4129H10.5856V18.7772ZM10.5856 16.1155H19.267V16.7493H10.5856V16.1155ZM10.5856 13.4537H19.267V14.0875H10.5856V13.4537ZM14.6056 10.7919H19.267V11.4258H14.6056V10.7919ZM13.6435 8V10.6901C13.6435 11.1428 13.4587 11.554 13.1587 11.8521L13.1568 11.854C12.8588 12.152 12.4457 12.3388 11.9967 12.3388H8.58789V23.8517C8.58789 24.1309 8.70296 24.3837 8.88595 24.5667C9.07082 24.7497 9.3236 24.8647 9.60279 24.8647H20.2517C20.5309 24.8647 20.7837 24.7497 20.9667 24.5667H20.9686C21.1516 24.3837 21.2666 24.1309 21.2666 23.8517V9.0149C21.2666 8.73571 21.1516 8.48293 20.9686 8.29994L20.9705 8.29806C20.7818 8.11319 20.529 8 20.2498 8H13.6435ZM13.0097 10.6901V8.37163L9.12553 11.7031H11.9967C12.274 11.7031 12.5287 11.588 12.7116 11.405L12.7135 11.4031C12.8965 11.222 13.0097 10.9693 13.0097 10.6901ZM20.2498 25.4986H14.3359L20.8214 27.9377C21.0818 28.034 21.3591 28.017 21.5968 27.9095C21.8326 27.8019 22.0288 27.6039 22.1268 27.3435L27.3485 13.4556C27.4466 13.1952 27.4277 12.9161 27.3202 12.6802C27.2127 12.4444 27.0165 12.2483 26.7543 12.1483L21.8986 10.3222V23.8498C21.8986 24.3026 21.7137 24.7138 21.4138 25.0138C21.1176 25.3137 20.7045 25.4986 20.2498 25.4986Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33083_178882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8248,
    height: 20,
    fill: "white",
    transform: "translate(8.58789 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.5cacee8c.svg";
export { ForwardRef as ReactComponent };